import { textColor, textSm, textXs, textXsSemibold } from '@insify/design-system/typography';
import { type MoneyField, formatMoney } from '@insify/global-money';
import clsx from 'clsx';

import * as styles from './AddOnCollapsible.module.css';

export type AddOnCollapsibleProps = {
  description?: string;
  coverageAmount: MoneyField;
  coverageAmountSubtext?: string;
};

export const AddOnCollapsible = ({ description, coverageAmountSubtext, coverageAmount }: AddOnCollapsibleProps) => {
  return (
    <div className={styles.container}>
      {description && <div className={clsx(textSm, textColor)}>{description}</div>}
      <div>
        <div className={textXsSemibold} data-testid='add-on-coverage-amount'>
          {formatMoney(coverageAmount, 'fr', {
            withoutFraction: true,
          })}
        </div>
        <div className={clsx(textXs, styles.subtitle)}>{coverageAmountSubtext}</div>
      </div>
    </div>
  );
};
